import {DichopticAssetKey, ICycle} from 'core/api/prescription'
import {minutesToMs} from 'core/utils/time-helpers'
import {TreatmentTemplates} from '../treatments'

const DICHOPTIC_MASKS = [{
  amblyopic: '/dichoptic-mask/2018-01-18-A3-A.png' as DichopticAssetKey,
  fellow:    '/dichoptic-mask/2018-01-18-A3-F.png' as DichopticAssetKey,
}, {
  amblyopic: '/dichoptic-mask/2018-01-18-B3-A.png' as DichopticAssetKey,
  fellow:    '/dichoptic-mask/2018-01-18-B3-F.png' as DichopticAssetKey,
}, {
  amblyopic: '/dichoptic-mask/2018-01-18-C3-A.png' as DichopticAssetKey,
  fellow:    '/dichoptic-mask/2018-01-18-C3-F.png' as DichopticAssetKey,
}, {
  amblyopic: '/dichoptic-mask/2018-01-18-D3-A.png' as DichopticAssetKey,
  fellow:    '/dichoptic-mask/2018-01-18-D3-F.png' as DichopticAssetKey,
}, {
  amblyopic: '/dichoptic-mask/2018-01-18-E3-A.png' as DichopticAssetKey,
  fellow:    '/dichoptic-mask/2018-01-18-E3-F.png' as DichopticAssetKey,
}, {
  amblyopic: '/dichoptic-mask/2018-01-18-F3-A.png' as DichopticAssetKey,
  fellow:    '/dichoptic-mask/2018-01-18-F3-F.png' as DichopticAssetKey,
}, {
  amblyopic: '/dichoptic-mask/2018-01-18-G3-A.png' as DichopticAssetKey,
  fellow:    '/dichoptic-mask/2018-01-18-G3-F.png' as DichopticAssetKey,
}, {
  amblyopic: '/dichoptic-mask/2018-01-18-H3-A.png' as DichopticAssetKey,
  fellow:    '/dichoptic-mask/2018-01-18-H3-F.png' as DichopticAssetKey,
}, {
  amblyopic: '/dichoptic-mask/2018-01-18-I3-A.png' as DichopticAssetKey,
  fellow:    '/dichoptic-mask/2018-01-18-I3-F.png' as DichopticAssetKey,
}, {
  amblyopic: '/dichoptic-mask/2018-01-18-J3-A.png' as DichopticAssetKey,
  fellow:    '/dichoptic-mask/2018-01-18-J3-F.png' as DichopticAssetKey,
}, {
  amblyopic: '/dichoptic-mask/2018-01-18-A2-A.png' as DichopticAssetKey,
  fellow:    '/dichoptic-mask/2018-01-18-A2-F.png' as DichopticAssetKey,
}, {
  amblyopic: '/dichoptic-mask/2018-01-18-B2-A.png' as DichopticAssetKey,
  fellow:    '/dichoptic-mask/2018-01-18-B2-F.png' as DichopticAssetKey,
}, {
  amblyopic: '/dichoptic-mask/2018-01-18-C2-A.png' as DichopticAssetKey,
  fellow:    '/dichoptic-mask/2018-01-18-C2-F.png' as DichopticAssetKey,
}, {
  amblyopic: '/dichoptic-mask/2018-01-18-D2-A.png' as DichopticAssetKey,
  fellow:    '/dichoptic-mask/2018-01-18-D2-F.png' as DichopticAssetKey,
}, {
  amblyopic: '/dichoptic-mask/2018-01-18-E2-A.png' as DichopticAssetKey,
  fellow:    '/dichoptic-mask/2018-01-18-E2-F.png' as DichopticAssetKey,
}, {
  amblyopic: '/dichoptic-mask/2018-01-18-F2-A.png' as DichopticAssetKey,
  fellow:    '/dichoptic-mask/2018-01-18-F2-F.png' as DichopticAssetKey,
}, {
  amblyopic: '/dichoptic-mask/2018-01-18-G2-A.png' as DichopticAssetKey,
  fellow:    '/dichoptic-mask/2018-01-18-G2-F.png' as DichopticAssetKey,
}, {
  amblyopic: '/dichoptic-mask/2018-01-18-H2-A.png' as DichopticAssetKey,
  fellow:    '/dichoptic-mask/2018-01-18-H2-F.png' as DichopticAssetKey,
}, {
  amblyopic: '/dichoptic-mask/2018-01-18-I2-A.png' as DichopticAssetKey,
  fellow:    '/dichoptic-mask/2018-01-18-I2-F.png' as DichopticAssetKey,
}, {
  amblyopic: '/dichoptic-mask/2018-01-18-J2-A.png' as DichopticAssetKey,
  fellow:    '/dichoptic-mask/2018-01-18-J2-F.png' as DichopticAssetKey,
}, {
  amblyopic: '/dichoptic-mask/2018-01-18-A1-A.png' as DichopticAssetKey,
  fellow:    '/dichoptic-mask/2018-01-18-A1-F.png' as DichopticAssetKey,
}, {
  amblyopic: '/dichoptic-mask/2018-01-18-B1-A.png' as DichopticAssetKey,
  fellow:    '/dichoptic-mask/2018-01-18-B1-F.png' as DichopticAssetKey,
}, {
  amblyopic: '/dichoptic-mask/2018-01-18-C1-A.png' as DichopticAssetKey,
  fellow:    '/dichoptic-mask/2018-01-18-C1-F.png' as DichopticAssetKey,
}, {
  amblyopic: '/dichoptic-mask/2018-01-18-D1-A.png' as DichopticAssetKey,
  fellow:    '/dichoptic-mask/2018-01-18-D1-F.png' as DichopticAssetKey,
}, {
  amblyopic: '/dichoptic-mask/2018-01-18-E1-A.png' as DichopticAssetKey,
  fellow:    '/dichoptic-mask/2018-01-18-E1-F.png' as DichopticAssetKey,
}, {
  amblyopic: '/dichoptic-mask/2018-01-18-F1-A.png' as DichopticAssetKey,
  fellow:    '/dichoptic-mask/2018-01-18-F1-F.png' as DichopticAssetKey,
}, {
  amblyopic: '/dichoptic-mask/2018-01-18-G1-A.png' as DichopticAssetKey,
  fellow:    '/dichoptic-mask/2018-01-18-G1-F.png' as DichopticAssetKey,
}, {
  amblyopic: '/dichoptic-mask/2018-01-18-H1-A.png' as DichopticAssetKey,
  fellow:    '/dichoptic-mask/2018-01-18-H1-F.png' as DichopticAssetKey,
}, {
  amblyopic: '/dichoptic-mask/2018-01-18-I1-A.png' as DichopticAssetKey,
  fellow:    '/dichoptic-mask/2018-01-18-I1-F.png' as DichopticAssetKey,
}, {
  amblyopic: '/dichoptic-mask/2018-01-18-J1-A.png' as DichopticAssetKey,
  fellow:    '/dichoptic-mask/2018-01-18-J1-F.png' as DichopticAssetKey,
}, {
  amblyopic: '/dichoptic-mask/2018-01-18-A0-A.png' as DichopticAssetKey,
  fellow:    '/dichoptic-mask/2018-01-18-A0-F.png' as DichopticAssetKey,
}, {
  amblyopic: '/dichoptic-mask/2018-01-18-B0-A.png' as DichopticAssetKey,
  fellow:    '/dichoptic-mask/2018-01-18-B0-F.png' as DichopticAssetKey,
}, {
  amblyopic: '/dichoptic-mask/2018-01-18-C0-A.png' as DichopticAssetKey,
  fellow:    '/dichoptic-mask/2018-01-18-C0-F.png' as DichopticAssetKey,
}, {
  amblyopic: '/dichoptic-mask/2018-01-18-D0-A.png' as DichopticAssetKey,
  fellow:    '/dichoptic-mask/2018-01-18-D0-F.png' as DichopticAssetKey,
}, {
  amblyopic: '/dichoptic-mask/2018-01-18-E0-A.png' as DichopticAssetKey,
  fellow:    '/dichoptic-mask/2018-01-18-E0-F.png' as DichopticAssetKey,
}, {
  amblyopic: '/dichoptic-mask/2018-01-18-F0-A.png' as DichopticAssetKey,
  fellow:    '/dichoptic-mask/2018-01-18-F0-F.png' as DichopticAssetKey,
}, {
  amblyopic: '/dichoptic-mask/2018-01-18-G0-A.png' as DichopticAssetKey,
  fellow:    '/dichoptic-mask/2018-01-18-G0-F.png' as DichopticAssetKey,
}, {
  amblyopic: '/dichoptic-mask/2018-01-18-H0-A.png' as DichopticAssetKey,
  fellow:    '/dichoptic-mask/2018-01-18-H0-F.png' as DichopticAssetKey,
}, {
  amblyopic: '/dichoptic-mask/2018-01-18-I0-A.png' as DichopticAssetKey,
  fellow:    '/dichoptic-mask/2018-01-18-I0-F.png' as DichopticAssetKey,
}, {
  amblyopic: '/dichoptic-mask/2018-01-18-J0-A.png' as DichopticAssetKey,
  fellow:    '/dichoptic-mask/2018-01-18-J0-F.png' as DichopticAssetKey,
}]

export const CYCLE_CAM1D_2_CONST_CONTRAST: ICycle = {
  name: 'CYCLE_CAM1D_2_CONST_CONTRAST',
  treatments: [
    {...TreatmentTemplates.DICHOPTIC_PRESENTATION__CAM1C_1, duration: minutesToMs(60)},
  ],
  assets: {
    dichopticMasks: DICHOPTIC_MASKS,
  },
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./core/src/prescription/treatment/cycles/cam1d-2.ts